<template>
    <div>
        <el-dialog :close-on-click-modal="clickClose" :model-value="dialogFormData.state" :destroy-on-close="true" draggable @close="close"
                   :width="width?width:650" :top="top + 'vh'" :align-center="center" :style="'max-height: ' + dialogHeight + 'px'">
            <template #header>
                <div class="title">
                    {{dialogFormData.title}}
                </div>
            </template>
            <el-scrollbar :max-height="(dialogHeight-220) + 'px'" >
                <el-form ref="dialogForm" :model="dialogFormData.data" :rules="dialogFormData.rules" inline>
                    <template v-for="(item, index) in dialogFormData.form" :key="index">
                        <!--  font类型         -->
                        <el-form-item v-if="item.type == 'font'&&(item.show==false?false:true)" :label="item.label" :prop="item.prop"
                                    :label-width="item.labelWidth?item.labelWidth:'80px'" >
                        <el-tooltip :content="item.tooltip&&item.tooltip.content" :placement="item.tooltip&&item.tooltip.placement"
                                    :show-after="item.tooltip&&item.tooltip.after?item.tooltip.after:1000"
                                    :disabled="item.tooltip&&item.tooltip.show&&item.tooltip.show==true?false:true">
                          <div class="row" :style="item.width?'width:'+item.width+'px':''" >{{dialogFormData.data[item.prop]}}</div>
                        </el-tooltip>
                        <el-alert class="form_alert" :style="item.alert&&item.alert.style?item.alert.style:''"
                                  :closable="false" v-if="item.alert">
                          <div v-html="item.alert&&item.alert.content?item.alert.content:''"></div>
                        </el-alert>
                      </el-form-item>
                        <!-- input类型 -->
                        <el-form-item v-if="item.type == 'text'&&(item.show==false?false:true)" :label="item.label" :prop="item.prop"
                                      :label-width="item.labelWidth?item.labelWidth:'80px'" >
                            <el-tooltip :content="item.tooltip&&item.tooltip.content" :placement="item.tooltip&&item.tooltip.placement"
                                        :show-after="item.tooltip&&item.tooltip.after?item.tooltip.after:1000"
                                        :disabled="item.tooltip&&item.tooltip.show&&item.tooltip.show==true?false:true">
                            <el-input class="row" :style="item.width?'width:'+item.width+'px':''" v-model.trim="dialogFormData.data[item.prop]"
                                      clearable :disabled="item.disabled" :maxlength="item.max?item.max:'30'"
                                      @input="handleInput(item)" @blur="(e)=>{if(item.blur)item.blur(e, item)}"
                                      :placeholder="item.placeholder?item.placeholder:'请输入' + item.label">
                                <template #append v-if="item.unit">{{item.unit}}</template>
                            </el-input>
                            </el-tooltip>
                            <el-alert class="form_alert" :style="item.alert&&item.alert.style?item.alert.style:''"
                                      :closable="false" v-if="item.alert">
                                <div v-html="item.alert&&item.alert.content?item.alert.content:''"></div>
                            </el-alert>
                        </el-form-item>
                        <!-- textarea类型 -->
                        <el-form-item v-if="item.type == 'textarea'&&(item.show==false?false:true)" :label="item.label" :prop="item.prop"
                                      :label-width="item.labelWidth?item.labelWidth:'80px'" >
                            <el-tooltip :content="item.tooltip&&item.tooltip.content" :placement="item.tooltip&&item.tooltip.placement"
                                        :show-after="item.tooltip&&item.tooltip.after?item.tooltip.after:1000"
                                        :disabled="item.tooltip&&item.tooltip.show&&item.tooltip.show==true?false:true">
                            <el-input class="row" type="textarea" :style="item.width?'width:'+item.width+'px':''"
                                      v-model="dialogFormData.data[item.prop]" autosize show-word-limit
                                      :disabled="item.disabled" :maxlength="item.max?item.max:'255'"
                                      @input="handleInput(item)" @blur="(e)=>{if(item.blur)item.blur(e, item)}"
                                      :placeholder="item.placeholder?item.placeholder:'请输入' + item.label" ></el-input>
                            </el-tooltip>
                        </el-form-item>
                        <!-- number1类型,可以加减的数字类型 -->
                        <el-form-item v-if="item.type == 'number1'&&(item.show==false?false:true)" :label="item.label" :prop="item.prop"
                                      :label-width="item.labelWidth?item.labelWidth:'80px'">
                            <el-input-number class="row" v-model="dialogFormData.data[item.prop]" :disabled="item.disabled"
                                             :style="item.width?'width:'+item.width+'px':''"
                                             :min="item.min?item.min:1" :max="item.max?item.max:9999" ></el-input-number>
                        </el-form-item>
                        <!-- select类型 -->
                        <el-form-item v-if="item.type == 'select'&&(item.show==false?false:true)" :label="item.label" :prop="item.prop"
                                      :label-width="item.labelWidth?item.labelWidth:'80px'">
                            <el-tooltip :content="item.tooltip&&item.tooltip.content" :placement="item.tooltip&&item.tooltip.placement"
                                        :show-after="item.tooltip&&item.tooltip.after?item.tooltip.after:1000"
                                        :disabled="item.tooltip&&item.tooltip.show&&item.tooltip.show==true?false:true">
                            <el-select class="row" v-model="dialogFormData.data[item.prop]" clearable :disabled="item.disabled"
                                       :style="item.width?'width:'+item.width+'px':''" :multiple="item.multiple==true?true:false"
                                       :placeholder="item.placeholder?item.placeholder:'请选择' + item.label"
                                       @change="(e)=>{if(item.change)item.change(e, item, index)}" >
                                <el-option v-for="(temp,index1) in item.sourceList" :key="index1"
                                           :label="item.sourceProp?temp[item.sourceProp.text]:temp.text"
                                           :value="item.sourceProp?temp[item.sourceProp.value]:temp.value" ></el-option>
                            </el-select>
                            </el-tooltip>
                        </el-form-item>
                        <!-- radio类型 -->
                        <el-form-item v-if="item.type == 'radio'&&(item.show==false?false:true)" :label="item.label" :prop="item.prop"
                                      :label-width="item.labelWidth?item.labelWidth:'80px'">
                            <el-radio-group class="row" v-model="dialogFormData.data[item.prop]" :disabled="item.disabled"
                                            :style="item.width?'width:'+item.width+'px':''"
                                            @change="(e)=>{if(item.change)item.change(e, item, index)}">
                                <el-radio v-for="(temp,index1) in item.sourceList" :key="index1" border :disabled="temp.disabled"
                                          :style="item.isLine?'margin-bottom: 10px!important;':''" style="min-width: 100px;"
                                          :value="item.sourceProp?temp[item.sourceProp.value]:temp.value+''" >
                                    {{item.sourceProp?temp[item.sourceProp.text]:temp.text}}</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <!-- checkbox类型 -->
                        <el-form-item v-if="item.type == 'checkbox'&&(item.show==false?false:true)" :label="item.label" :prop="item.prop"
                                      :label-width="item.labelWidth?item.labelWidth:'80px'">
                            <el-checkbox-group class="row" v-model="dialogFormData.data[item.prop]" :disabled="item.disabled"
                                               :style="item.width?'width:'+item.width+'px':''"
                                               @change="(e)=>{if(item.change)item.change(e, item, index)}">
                                <el-checkbox v-for="(temp,index1) in item.sourceList" :key="index1" border :disabled="temp.disabled"
                                             :style="item.isLine?'margin-bottom: 10px!important;':''" style="min-width: 100px;"
                                             :value="item.sourceProp?temp[item.sourceProp.value]+'':temp.value+''" >
                                    {{item.sourceProp?temp[item.sourceProp.text]:temp.text}}</el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>
                        <!-- date类型 -->
                        <el-form-item v-if="item.type == 'date'&&(item.show==false?false:true)" :label="item.label" :prop="item.prop"
                                      :label-width="item.labelWidth?item.labelWidth:'80px'">
                            <el-date-picker v-model="dialogFormData.data[item.prop]" :type="item.dateType?item.dateType:'datetime'"
                                            :style="item.width?'width:'+item.width+'px':''"
                                            :placeholder="item.placeholder?item.placeholder:'请输入' + item.label"
                                            @change="(e)=>{if(item.change)item.change(e, item, index)}" ></el-date-picker>
                        </el-form-item>
                        <!-- time类型 -->
                        <el-form-item v-if="item.type == 'time'&&(item.show==false?false:true)" :label="item.label" :prop="item.prop"
                                      :label-width="item.labelWidth?item.labelWidth:'80px'">
                            <el-time-picker v-model="dialogFormData.data[item.prop]" is-range range-separator="--"
                                            :style="item.width?'width:'+item.width+'px':''" :format="item.format?item.format:'HH:mm:ss'"
                                            @change="(e)=>{if(item.change)item.change(e, item)}"
                                            start-placeholder="请选择开始时间" end-placeholder="请选择结束时间" ></el-time-picker>
                        </el-form-item>
                        <!-- mtTime类型 -->
                        <el-form-item v-if="item.type == 'mtTime'&&(item.show==false?false:true)" :label="item.label" :prop="item.prop"
                                      :label-width="item.labelWidth?item.labelWidth:'80px'">
                            <el-dropdown trigger="click" ref="mtTime" max-height="300" >
                                <div class="diy" style="height: 32px;"
                                     :class="dialogFormData.data[item.prop]?'diy_value':'',item.disabled==true?'disabled':''">
                                    <span v-if="dialogFormData.data[item.prop]">{{dialogFormData.data[item.prop]}}</span>
                                    <span v-else>{{item.placeholder?item.placeholder:'请选择' + item.label}}</span>
                                    <el-icon class="diy_clear" size="15" color="#ababab" v-if="dialogFormData.data[item.prop]"
                                             @click.stop="(e)=>{if(item.click&&item.disabled==true?false:true)dialogFormData.data[item.prop]=''}">
                                        <CircleClose />
                                    </el-icon>
                                </div>
                                <template #dropdown>
                                    <div class="mtTime">
                                        <div class="mtTime_date" >
                                            <div class="mtTime_item" :class="item.day == 'today'?'mtTime_item_select':''"
                                                 @click="(e)=>{mtTimeClick('day', 'today', item)}">今日</div>
                                            <div class="mtTime_item" :class="item.day == 'tomorrow'?'mtTime_item_select':''"
                                                 @click="(e)=>{mtTimeClick('day', 'tomorrow', item)}" v-if="item.tomorrow">次日</div>
                                        </div>
                                        <div class="mtTime_date">
                                            <el-scrollbar>
                                                <template v-for="(data,k) in item.mtHrList ">
                                                    <div class="mtTime_item" :class="item.hour == data?'mtTime_item_select':''"
                                                        @click="(e)=>{mtTimeClick('hour', data, item)}">{{data}}</div>
                                                </template>
                                            </el-scrollbar>
                                        </div>
                                        <div class="mtTime_date">
                                            <el-scrollbar>
                                                <template v-for="(data,k) in item.mtMinList ">
                                                    <div class="mtTime_item" :class="item.minute == data?'mtTime_item_select':''"
                                                         @click="(e)=>{mtTimeClick('minute', data, item)}">{{data}}</div>
                                                </template>
                                            </el-scrollbar>
                                        </div>
                                    </div>
                                </template>
                            </el-dropdown>
                        </el-form-item>
                        <!-- image类型 -->
                        <el-form-item v-if="item.type == 'image'&&(item.show==false?false:true)" :label="item.label" :prop="item.prop"
                                      :label-width="item.labelWidth?item.labelWidth:'80px'" >
                            <el-tooltip :content="item.tooltip&&item.tooltip.content" :placement="item.tooltip&&item.tooltip.placement"
                                        :show-after="item.tooltip&&item.tooltip.after?item.tooltip.after:1000"
                                        :disabled="item.tooltip&&item.tooltip.show&&item.tooltip.show==true?false:true">
                                <el-upload class="row " v-model:file-list="item.imageList" list-type="picture-card" :auto-upload="false" multiple
                                           accept=".jpg,.jpeg,.png,.gif,.bmp,.JPG,.JPEG,.GIF,.BMP" :limit="item.limit" :disabled="item.disabled"
                                           :style="item.width?'width:'+item.width+'px':''"
                                           :on-preview="handlePreview"
                                           :on-exceed="handleExceed"
                                           :on-change="(e)=>{uploadChange(e, item)}"
                                           :on-remove="(e)=>{handleRemove(e, item)}" >
                                    <el-icon><Plus /></el-icon>
                                </el-upload>
                            </el-tooltip>
                        </el-form-item>
                        <!-- 树状图 -->
                        <el-form-item v-if="item.type == 'tree'&&(item.show==false?false:true)" :label="item.label" :prop="item.prop"
                                      :label-width="item.labelWidth?item.labelWidth:'80px'" >
                            <el-tree ref="tree" class="row" show-checkbox node-key="id" :style="item.width?'width:'+item.width+'px':''"
                                     :data="item.treeData" :check-strictly="true"
                                     :default-checked-keys="item.checkData"
                                     :default-expand-all="true"
                                     :props="{ children: item.children, label: item.treeLabel, class: treeClass }"
                                     @check="(click, checked)=>{handleCheckChange(click, checked)}"
                            ></el-tree>
                        </el-form-item>
                        <!-- 自定义数据行 -->
                        <el-form-item v-if="item.type == 'diy'&&(item.show==false?false:true)" :label="item.label" :prop="item.prop"
                                      :label-width="item.labelWidth?item.labelWidth:'80px'">
                            <div class="diy" :class="dialogFormData.data[item.prop]?'diy_value':'',item.disabled==true?'disabled':''"
                                 @click="(e)=>{if(item.click&&item.disabled==true?false:true)item.click(item)}">
                                {{dialogFormData.data[item.prop]?dialogFormData.data[item.prop]:item.placeholder}}
                                <el-icon class="diy_clear" size="15" color="#ababab" v-if="dialogFormData.data[item.prop]"
                                         @click.stop="(e)=>{if(item.click&&item.disabled==true?false:true)dialogFormData.data[item.prop]=''}">
                                    <CircleClose />
                                </el-icon>
                            </div>
                        </el-form-item>
                        <!-- 多行 -->
                        <template v-if="item.type == 'list'&&(item.show==false?false:true)">
                            <el-card class="item_card" v-for="(data,k) in item.listData" :key="k" shadow="never"
                                     :style="item.listWidth?'width:'+item.listWidth+'%':''">
                                <template v-for="(temp,i) in item.listForm" :key="i">
                                <!-- 消息提示 -->
                                <template v-if="temp.type == 'tips'&&(item.listData[k][temp.prop])" >
                                    <div :style="item.listData[k][temp.prop + '_style']"
                                         style="height: 32px;display: flex;align-items: center;justify-content: start;">
                                        {{item.listData[k][temp.prop]}}</div>
                                </template>
                                <!-- radio类型 -->
                                <el-form-item v-if="temp.type == 'radio'&&(temp.show==false?false:true)" :label="temp.label" :prop="temp.prop"
                                              :label-width="temp.labelWidth?temp.labelWidth:'80px'">
                                    <el-radio-group class="row" v-model="item.listData[k][temp.prop]" :disabled="temp.disabled"
                                                    :style="temp.width?'width:'+temp.width+'px':''"
                                                    @change="(e)=>{if(temp.change)temp.change(e, temp, i)}">
                                        <el-radio v-for="(temp1,index1) in temp.sourceList" :key="index1" border :disabled="temp1.disabled"
                                                  :style="temp.isLine?'margin-bottom: 10px!important;':''" style="min-width: 100px;"
                                                  :value="temp.sourceProp?temp1[temp.sourceProp.value]:temp1.value" >
                                            {{temp.sourceProp?temp1[temp.sourceProp.text]:temp1.text}}</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <!-- input类型 -->
                                <el-form-item v-if="temp.type == 'text'&&(temp.show==false?false:true)" :label="temp.label" :prop="temp.prop"
                                              :label-width="temp.labelWidth?temp.labelWidth:'80px'" >
                                    <el-input class="row" :style="temp.width?'width:'+temp.width+'px':''" clearable
                                              v-model.trim="item.listData[k][temp.prop]" :disabled="temp.disabled"
                                              @input="handleListInput(index, k, temp)"  :maxlength="temp.max?temp.max:'200'"
                                              @blur="(e)=>{if(temp.blur)temp.blur(temp, k)}"
                                              :placeholder="temp.placeholder?temp.placeholder:'请输入' + temp.label"></el-input>
                                </el-form-item>
                                <!-- select类型 -->
                                <el-form-item v-if="temp.type == 'select'&&(temp.show==false?false:true)" :label="temp.label" :prop="temp.prop"
                                              :label-width="temp.labelWidth?temp.labelWidth:'80px'" >
                                    <el-select class="row" v-model="item.listData[k][temp.prop]" clearable :disabled="temp.disabled"
                                               :style="temp.width?'width:'+temp.width+'px':''" :multiple="temp.multiple==true?true:false"
                                               :placeholder="temp.placeholder?temp.placeholder:'请选择' + temp.label"
                                               @change="(e)=>{if(temp.change)temp.change(e, temp, i)}" >
                                        <el-option v-for="(temp1,index1) in temp.sourceList" :key="index1"
                                                   :label="temp1[temp.sourceProp.text]" :disabled="temp1.disabled"
                                                   :value="temp1[temp.sourceProp.value]" ></el-option>
                                    </el-select>
                                </el-form-item>
                                <!-- number1类型,可以加减的数字类型 -->
                                <el-form-item v-if="temp.type == 'number1'&&(temp.show==false?false:true)" :label="temp.label" :prop="temp.prop"
                                              :label-width="temp.labelWidth?temp.labelWidth:'80px'">
                                    <el-input-number class="row" v-model="item.listData[k][temp.prop]" :disabled="temp.disabled"
                                                     :style="temp.width?'width:'+temp.width+'px':''"
                                                     :min="temp.min?temp.min:1" :max="temp.max?temp.max:9999" ></el-input-number>
                                </el-form-item>
                                </template>
                                <!-- 删除按钮 -->
                                <template v-if="k != 0">
                                    <el-button class="item_card_btn" type="danger" circle v-if="item.listIsClick==false?false:true"
                                               @click="(e)=>{if(item.click&&item.disabled==true?false:true)item.click('delete', k)}">
                                        <el-icon class="item_card_btn_icon" size="16" color="#ffffff"><Close /></el-icon>
                                    </el-button>
                                </template>
                                <!-- 新增按钮 -->
                                <template v-if="k == item.listData.length - 1">
                                    <el-button class="item_card_btn1" color="#ff6633" type="primary" v-if="item.listIsClick==false?false:true"
                                               @click="(e)=>{if(item.click&&item.disabled==true?false:true)item.click('add', '')}">
                                        <el-icon size="16" color="#ffffff"><Plus /></el-icon> {{item.listBtn?item.listBtn:'新增行'}}
                                    </el-button>
                                </template>
                                <!-- 删除按钮(所有行都可以删除) -->
                                <template v-if="item.listIsClick==false&&item.onlyDelete">
                                    <el-button class="item_card_btn" type="danger" circle
                                               @click="(e)=>{if(item.click&&item.disabled==true?false:true)item.click('delete', k)}">
                                        <el-icon class="item_card_btn_icon" size="16" color="#ffffff"><Close /></el-icon>
                                    </el-button>
                                </template>
                            </el-card>

                        </template>
                        <!-- button类型 -->
                        <template v-if="item.type == 'button'&&(item.show==false?false:true)">
                            <buttons :buttons="item.buttons" :access="item.access?item.access:[]"
                                     :diy="item.diy?item.diy:{}"
                                     :diy1="item.diy1?item.diy1:{}"
                                     :diy2="item.diy2?item.diy2:{}"
                                     :diy3="item.diy3?item.diy3:{}"
                                     :diy4="item.diy4?item.diy4:{}"
                                     @btnClick="item.btnClick" ></buttons>
                        </template>
                        <!-- title类型 -->
                        <template v-if="item.type == 'title'&&(item.show==false?false:true)">
                            <div class="row_title" :style="item.style?item.style:''" > <div class="row_title_icon"></div>{{item.label}}</div>
                        </template>
                        <!-- table类型 -->
                        <template v-if="item.type == 'table'&&(item.show==false?false:true)">
                            <tables style="padding-bottom: 20px" :tableData="item.tableData" tableKey="dialogForm" :isForm="true"></tables>
                        </template>

                    </template>
                </el-form>
            </el-scrollbar>
            <template #footer>
                <el-button @click="dialogFormData.state = false">取 消</el-button>
                <el-button @click="onSubmit" color="#ff6633" type="primary">{{dialogFormData.saveBtnText?dialogFormData.saveBtnText:'保 存'}}</el-button>
            </template>
        </el-dialog>

        <!-- 预览图片 -->
        <el-dialog v-model="dialogVisible" draggable align-center close-on-click-modal>
            <template #header>
                <div class="title">预览图片</div>
            </template>
            <img style="width: 100%;" :src="dialogImageUrl"  />
        </el-dialog>

    </div>
</template>

<script>
    //region 表单数据说明
    /*dialogFormData: {
       //窗口显示状态
       state: true,
       //窗口标题
       title: '新建商户',
       //表单结构
       form: [
           {
            //基础字段---------------------------
            label: "选择用户",          //标题
            prop: 'createUserNick',    //字段
            placeholder:'请选择用户',   //placeholder值,默认使用标题组成
            labelWidth:500,            //标题宽度
            width:500,                 //内容宽度
            max:4,                     //最大长度
            disabled:true,             //是否可用
            show:true,                 //是否显示
            tooltip:{},                //提示框对象, eg:tooltip: {content:'可以',placement:'bottom',show:true,after:1000}
            tableData: [],             //table使用,同table组件
            isValid:"",                //正则校验输入规则,具体看input回调方法(handleInput)

            type: 'diy',               //类型, text:文本,date:日期选择,time时间选择 select:下拉选择, radio:单项选择, image:图片, diy:自定义列,
                                               tree:树状图,list:多行操作, table:表格类型, button:按钮列(使用同button),mtTime:美团选择时间,
                                               number:数字类型, checkbox:多项选择, textarea:文本域类型, tips:提示类型
            //----------------------------------

            //其他组件公共拓展字段----------------
            sourceList:[],             //选项集合(radio, checkbox, select) eg:[{value:'选择值', text:'展示文本'}]
            sourceProp:{},             //选项集合对应的键值对(radio, checkbox, select) eg:{ value:'label', text: 'text' }
            isLine:true,               //是否有换行(radio, checkbox)

            multiple: false,           //select是否多选

            treeData:[],               //tree使用,树状图数据
            checkData:[],              //tree使用,已选择的数据
            treeLabel:'displayName',   //tree使用,树状图展示名称key
            children: 'powerList'      //tree使用,树状图子集key

            imageList:[],              //image使用,图片集合,image不能使用表单数据,需要额外在此集合赋值 eg:['xxxurl', 'sssurl']
            limit:1,                   //image使用,上传图片的数量限制
            isUpload:true,             //image使用,向后台上传图片

            isRange:false,             //time使用,是否时间限制
            format:'HH:mm:ss',         //time使用,格式化

            dateType:'',               //date使用,日期的类型:year/month/date/dates/datetime/week/datetimerange/daterange/ monthrange

            day:'',                    //mtTime使用,选择天
            hour:'',                   //mtTime使用,选择小时
            minute:'',                 //mtTime使用,选择分钟
            mtHrList:'',               //mtTime使用,小时集合
            mtMinList:'',              //mtTime使用,分钟集合
            tomorrow:'false',          //mtTime使用,是否显示次日
            change:res=>{},            //mtTime使用,选择完回调
            min:'0',                   //number使用,最小值
            max:'999',                 //number使用,最大值

            //----------------------------------

            //其他组件公共回调事件----------------
            change:(e, item, index)=>{} //当绑定值变化时触发的事件(radio, checkbox, select, date)
            click: res=>{}              //点击事件回调(diy,list)
            input:res=>{}               //input事件回调,如果是list调用,返回值是(res, k)
            blur:res=>{}                //blur事件回调
            //----------------------------------

            //type:list多行操作拓展字段----------
            listData:[],                //list表单数据
            listForm:[],                //list表单结构(同上面form)
            listIsClick:true,           //是否有点击按钮,默认true
            listBtn: '',                //按钮名
            listWidth:'',               //外部宽度 默认:94%
            onlyDelete:true,            //所有行都可以删除, item.listIsClick必须是false
            //----------------------------------

           },
       ],
       //表单数据
       data:{},
       //表单校验规则,此处只校验必填,其他校验在输入时候校验
       rules: {
           //说明: companyName:列名, required:必填, message:提示消息, trigger:校验方式(blur,change),
           companyName: [
               {required: true, message: '请输入商户名称', trigger: 'blur'},
           ],
       },
       //表单提交回调
       onSubmit: res => {}
    }*/
    //endregion
    import tables from '@/components/tables.vue'
    import buttons from '@/components/buttons.vue'

    export default {
        name: "dialogForm", //弹出表单窗口组件
        components:{
            tables,
            buttons,
        },
        props: {
            //点击其他地方是否可以关闭页面
            clickClose:{
                type: Boolean,
                default: false
            },
            //窗口宽度
            width:{
                type: null,
                default: null
            },
            //窗口距顶部距离
            top:{
                type: Number,
                default: 15
            },
            //窗口是否上下左右居中
            center:{
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                dialogFormData:{},
                dialogHeight: `${document.documentElement.clientHeight}`,
                checkedList:[],             //树状图选中的数据
                dialogVisible: false,       //是否预览图片
                dialogImageUrl:'',          //预览图片链接
            }
        },
        methods:{

            /**
             * 美团时间点击
             */
            mtTimeClick(type, data, item){
                switch (type) {
                    //region 天
                    case 'day':
                        item.day = data;
                        //判断是否已选完
                        if(item.day && item.hour && item.minute){
                            //关闭所有选择时间
                            let refs = this.$refs['mtTime'];
                            if(refs && refs.length > 0){
                                for (let i = 0; i < refs.length; i++) {
                                    refs[i].handleClose();
                                }
                            }
                            //回调
                            if(item.change){
                                item.change(item.day, item.hour, item.minute, this)
                            }
                            //清空已选
                            item.hour = "";
                            item.minute = "";
                        }
                        break;
                        //endregion
                    //region 小时
                    case 'hour':
                        item.hour = data;
                        //判断是否已选完
                        if(item.day && item.hour && item.minute){
                            //关闭所有选择时间
                            let refs = this.$refs['mtTime'];
                            if(refs && refs.length > 0){
                                for (let i = 0; i < refs.length; i++) {
                                    refs[i].handleClose();
                                }
                            }
                            //回调
                            if(item.change){
                                item.change(item.day, item.hour, item.minute, this)
                            }
                            //清空已选
                            item.hour = "";
                            item.minute = "";
                        }
                        break;
                        //endregion
                    //region 分钟
                    case 'minute':
                        item.minute = data;
                        //判断是否已选完
                        if(item.day && item.hour && item.minute){
                            //关闭所有选择时间
                            let refs = this.$refs['mtTime'];
                            if(refs && refs.length > 0){
                                for (let i = 0; i < refs.length; i++) {
                                    refs[i].handleClose();
                                }
                            }
                            //回调
                            if(item.change){
                                item.change(item.day, item.hour, item.minute, this)
                            }
                            //清空已选
                            item.hour = "";
                            item.minute = "";
                        }

                        break;
                        //endregion
                }

            },

            /**
             * 文本输入(校验数据)
             */
            handleInput(e){
                //根据isValid过滤数据
                if(e.isValid){
                    switch (e.isValid) {
                        //region 数字
                        case "number":
                            this.dialogFormData.data[e.prop] = this.dialogFormData.data[e.prop].replace(/[^\d]/g,'');
                            break;
                        //endregion
                        //region 数字大于零
                        case "numberNotZero":
                            this.dialogFormData.data[e.prop] = this.dialogFormData.data[e.prop].replace(/[^\d]/g,'');
                            if(this.dialogFormData.data[e.prop] == 0){
                                this.dialogFormData.data[e.prop] = ""
                            }
                            break;
                        //endregion
                        //region 只能输入数字和两位小数
                        case "money":
                            this.dialogFormData.data[e.prop] = this.dialogFormData.data[e.prop].replace(/[^\d.]/g,""); //清除"数字"和"."以外的字符
                            this.dialogFormData.data[e.prop] = this.dialogFormData.data[e.prop].replace(/^\./g,""); //验证第一个字符是数字
                            this.dialogFormData.data[e.prop] = this.dialogFormData.data[e.prop].replace(/\.{2,}/g,""); //只保留第一个, 清除多余的
                            this.dialogFormData.data[e.prop] = this.dialogFormData.data[e.prop].replace(".","$#$").replace(/\./g,"").replace("$#$",".");
                            this.dialogFormData.data[e.prop] = this.dialogFormData.data[e.prop].replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3'); //只能输入两个小数
                            break;
                        //endregion
                    }
                }
                //如果有回调
                if(e.input){
                    return e.input(e);
                }
            },

            /**
             * list类型文本输入(校验数据)
             */
            handleListInput(index, k, e){
                if(e.isValid){
                    switch (e.isValid) {
                        //region 数字
                        case "number":
                            this.dialogFormData.form[index].listData[k][e.prop] = this.dialogFormData.form[index].listData[k][e.prop].replace(/[^\d]/g,'');
                            break;
                        //endregion
                        //region 只能输入数字和两位小数
                        case "money":
                            this.dialogFormData.form[index].listData[k][e.prop] = this.dialogFormData.form[index].listData[k][e.prop].replace(/[^\d.]/g,""); //清除"数字"和"."以外的字符
                            this.dialogFormData.form[index].listData[k][e.prop] = this.dialogFormData.form[index].listData[k][e.prop].replace(/^\./g,""); //验证第一个字符是数字
                            this.dialogFormData.form[index].listData[k][e.prop] = this.dialogFormData.form[index].listData[k][e.prop].replace(/\.{2,}/g,""); //只保留第一个, 清除多余的
                            this.dialogFormData.form[index].listData[k][e.prop] = this.dialogFormData.form[index].listData[k][e.prop].replace(".","$#$").replace(/\./g,"").replace("$#$",".");
                            this.dialogFormData.form[index].listData[k][e.prop] = this.dialogFormData.form[index].listData[k][e.prop].replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3'); //只能输入两个小数
                            break;
                        //endregion
                    }
                }
                //如果有回调
                if(e.input){
                    return e.input(e, k);
                }
            },

            /**
             * 预览点击
             */
            handlePreview(e){
                this.dialogImageUrl = e.url;
                this.dialogVisible = true;
            },

            /**
             * 超出限制
             */
            handleExceed(){
                this.$message.warning("已达最大上传数量!");
            },

            /**
             * 移除点击
             */
            handleRemove(e, item){
                let imageList = this.$tools.getIndex(this.dialogFormData.form, item.prop).imageList;
                //如果是已上传云端的图片,则删除
                if(item.isUpload){
                    this.$POST1("/author/EomsUser/deleteImage", {imageUrl: e.url}).then(res => {
                        if(imageList.length > 0){
                            //把第一张图片放到表单,用于校验
                            this.dialogFormData.data[item.prop] = imageList[0];
                        }else{
                            this.dialogFormData.data[item.prop] = null;
                        }
                        //校验此列
                        this.$refs.dialogForm.validateField(item.prop)
                    })
                }else{
                    if(imageList.length > 0){
                        //把第一张图片放到表单,用于校验
                        this.dialogFormData.data[item.prop] = imageList[0];
                    }else{
                        this.dialogFormData.data[item.prop] = null;
                    }
                    //校验此列
                    this.$refs.dialogForm.validateField(item.prop)
                }
            },

            /**
             * 上传成功后
             */
            uploadChange(e, item){
                //上传图片
                if(item.isUpload){
                    let param = {
                        imageFile: e.raw
                    };
                    this.$POST1("/author/EomsUser/uploadImage", this.$tools.getFormData(param), true, "上传中...", false).then(res => {
                        //把imgList里的临时图片替换成返回的
                        let imageList = this.$tools.getIndex(this.dialogFormData.form, item.prop).imageList;
                        for (let i = 0; i < imageList.length; i++) {
                            if(imageList[i].uid == e.uid){
                                imageList[i].url = res.data
                            }
                        }
                        if(imageList.length > 0){
                            //把第一张图片放到表单,用于校验
                            this.dialogFormData.data[item.prop] = imageList[0];
                            //校验此列
                            this.$refs.dialogForm.validateField(item.prop)
                        }
                    })
                }
                //不需要上传,本地处理
                else{
                    //延迟判断,否则imageList里没有数据
                    setTimeout(res => {
                        let imageList = this.$tools.getIndex(this.dialogFormData.form, item.prop).imageList;
                        if(imageList.length > 0){
                            //把第一张图片放到表单,用于校验
                            this.dialogFormData.data[item.prop] = imageList[0];
                            //校验此列
                            this.$refs.dialogForm.validateField(item.prop)
                        }
                    },10)

                }
            },

            /**
             * 节点被被点击
             */
            handleCheckChange(data, checked) {
                for (let k = 0; k < this.dialogFormData.form.length; k++) {
                    if(this.dialogFormData.form[k].type == "tree"){
                        let ongFlag = false;
                        let twoFlag = false;
                        let list = this.dialogFormData.form[k].treeData;
                        for (let i = 0; i < list.length; i++) {
                            //修改一级选中
                            if(data.id == list[i].id){
                                list[i].isSelected = !list[i].isSelected;
                                ongFlag = true;
                            }else{
                                ongFlag = false;
                            }
                            //修改二级选中
                            if(list[i].powerList.length > 0){
                                let list1 = list[i].powerList;
                                for (let k = 0; k < list1.length; k++) {
                                    //修改
                                    if(data.id == list1[k].id){
                                        list1[k].isSelected = !list1[k].isSelected;
                                        twoFlag = true;
                                    }else{
                                        twoFlag = false;
                                    }
                                    //一级被修改联动二级
                                    if(ongFlag){
                                        list1[k].isSelected = list[i].isSelected
                                    }
                                    //修改三级选中
                                    if(list1[k].powerList.length > 0){
                                        let list2 = list1[k].powerList;
                                        for (let j = 0; j < list2.length; j++) {
                                            if(data.id == list2[j].id){
                                                list2[j].isSelected = !list2[j].isSelected;
                                            }
                                            //一级被修改联动三级
                                            if(ongFlag){
                                                list2[j].isSelected = list[i].isSelected
                                            }
                                            //二级被修改联动三级
                                            if(twoFlag){
                                                list2[j].isSelected = list1[k].isSelected
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        //重新设置
                        this.$refs.tree[0].setCheckedKeys(this.$tools.getPowerCheckedKeys(list,[]));
                        this.dialogFormData.form[k].checkData = this.$tools.getPowerCheckedKeys(list,[]);
                    }
                }
            },

            /**
             * 树状图自定义class
             */
            treeClass(e){
                //按层级返回自定义样式
                if (e.powerCode && e.powerCode.length == 0) {
                    return 'node_lv1'
                }
                else if (e.powerCode && e.powerCode.length == 3) {
                    return 'node_lv2'
                }
                else if (e.powerCode && e.powerCode.length == 6) {
                    return 'node_lv3'
                }
                return null
            },

            /**
             * 表单提交
             */
            onSubmit(e){
                this.$refs.dialogForm.validate((valid) => {
                    if (valid) {
                        return this.dialogFormData.onSubmit(this.dialogFormData)
                    }
                })
            },

            /**
             * 关闭回调
             */
            close(){
                this.dialogFormData.state = false
            },

            /**
             * 初始化数据
             */
            initData(e){
                this.dialogFormData = e;
            },
        },
        mounted() {
        }
    }
</script>

<style scoped>

    /*行标题*/
    .row_title{
        position: relative;
        height: 30px;
        font-size: 16px;
    }
    .row_title_icon{
        position: relative;
        bottom: 0;
        height: 12px;
        width: 6px;
        background: linear-gradient(to bottom, #ff6633, #ff6633);
        border-radius: 4px;
        margin-right: 4px;
        display: inline-block;
    }

    /*美团选择时间*/
    .mtTime{
        position: relative;
        width: 200px;
        display: flex;
        justify-content: flex-start;
        font-size: 14px;
    }
    .mtTime_date{
        position: relative;
        width: 33%;
        padding-top: 10px;
        padding-bottom: 10px;
        border-right: 1px solid #f0f0f0;
        max-height: 280px;
    }
    .mtTime_item{
        position: relative;
        width: 100%;
        height: 34px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }
    .mtTime_item:hover{
        color: #ffbe88;
    }
    .mtTime_item_select{
        background: #ff6633;
        color: #ffffff;
        border-radius: 2px;
    }

    .title{
        font-weight: 800;
        font-size: 17px;
    }
    :deep(.el-dialog__header){
        border-bottom: 1px solid #f2f2f2;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
    }
    :deep(.el-dialog__body){
        margin-top: 20px;
    }
    :deep(.el-dialog__close) {
        font-size: 24px!important;
    }
    :deep(.el-dialog) {
        border-radius: 8px;
    }
    :deep(.el-button+.el-button) {
        color: #ffffff;
    }
    :deep(.el-form--inline .el-form-item){
        margin-right: 20px;
    }
    .row{
        width: 200px;
    }
    .diy{
        display: inline-flex;
        align-items: center;
        justify-content: flex-start;
        flex-grow: 1;
        padding: 1px 11px;
        background-color: #ffffff;
        background-image: none;
        border-radius: 4px;
        transition: var(--el-transition-box-shadow);
        box-shadow: 0 0 0 1px #dcdfe6 inset;
        width: 180px;
        cursor: pointer;
        color: #ababab;
    }
    .diy:hover{
        box-shadow: 0 0 0 1px #409eff inset!important;
    }
    .diy:focus{
      outline: none !important;
    }
    .diy_value{
        color: #333333;
    }
    .disabled{
        color: #ababab;
        background: #f5f7fa;
        cursor: not-allowed;
    }
    .disabled:hover{
        box-shadow: 0 0 0 1px #dcdfe6 inset;
    }
    .diy_clear{
        position: absolute;
        right: 8px;
        top: 10px;
    }

    /*第三级开始一行显示*/
    :deep(.node_lv3) {
        display: inline-block;
    }
    /*设置第二行靠左距离*/
    :deep(.node_lv2>.el-tree-node__children){
        padding-left: 59px!important;
    }
    /*设置第三行靠左距离*/
    :deep(.node_lv3>.el-tree-node__children){
        padding-left: 59px!important;
    }
    /*设置行间距*/
    :deep(.el-tree-node__children){
        white-space: pre-wrap;
        line-height: 12px;
    }
    /*设置第三级开始内边距*/
    :deep(.node_lv3 .el-tree-node__content) {
        padding-left: 5px!important;
        padding-right: 5px;
    }
    /*设置第三级不显示标签*/
    :deep(.node_lv3 .el-tree-node__expand-icon.is-leaf) {
        display: none;
    }

    /*多行表单关闭样式*/
    .item_card_btn{
        position: absolute;
        border-radius: 50%;
        height: 40px;
        width: 40px;
        top: -17px;
        right: -17px;
        color: #ffffff;
    }
    .item_card_btn_icon{
        position: relative;
        left: -7px;
        top: 8px;
        color: #ffffff;
    }
    /*多行表单样式*/
    .item_card{
        position: relative;
        width: 94%;
        display: flex;
        margin-bottom: 10px;
        margin-left: 12px;
    }
    :deep(.item_card .el-card__body) {
        display: flex;
        justify-content: start;
        flex-wrap: wrap;
    }
    .item_card_btn1{
        position: relative;
        margin-left: 12px;
        color: #ffffff;
    }

    /*radio样式*/
    :deep(.el-radio) {
        margin-right: 10px!important;
    }

    /*checkbox样式*/
    :deep(.el-checkbox) {
        margin-right: 10px!important;
    }


    /*image样式*/
    :deep(.el-upload--picture-card ){
        --el-upload-picture-card-size: 100px!important;
    }
    :deep(.el-upload-list__item ){
        height: 100px!important;
        width: 100px!important;
    }
</style>
